// 텍스트 이펙트 레지스트리 — 새 효과는 여기에 등록만 하면 TextLayer/인스펙터가 인식한다.
import type { TextEffectDef, TextEffectType } from './types';
import { typewriterEffect } from './typewriter';
import { countUpEffect } from './countup';

/** 등록된 텍스트 이펙트. 새 효과 추가 = 이 맵에 항목 추가. */
export const TEXT_EFFECTS: Record<TextEffectType, TextEffectDef> = {
  typewriter: typewriterEffect,
  countUp: countUpEffect,
};

/**
 * type 으로 효과 정의를 가져온다. 미등록(레지스트리 누락) 시 undefined.
 * 호출부는 fallback(효과 미적용) 처리해, 등록 누락이 silent crash 로 번지지 않게 한다.
 */
export function getTextEffect(type: TextEffectType): TextEffectDef | undefined {
  return TEXT_EFFECTS[type];
}

/** 인스펙터 드롭다운용 효과 목록(레지스트리 순서). */
export function listTextEffects(): TextEffectDef[] {
  return Object.values(TEXT_EFFECTS);
}
